<template>
  <div class="content">
    <h2>Average Time to CFU Completion</h2>
    <h1 class="hero">{{timeParse(cfuAverage)}}</h1>
    <p>Longest <strong>{{timeParse(cfuLongest)}}</strong> <br>Shortest <strong>{{timeParse(cfuShortest)}}</strong></p>
  </div>
</template>

<script>
export default {
  name: "AverageCFUCompletion",
  props: ["taskProgress", "groupLength"],
  computed: {
    taskProgressObject(){
      return this.taskProgress;
    },
    cfuAverage(){
      var arr = [];
      this.taskProgressObject.forEach((item) =>
        arr.push(item[0] + item[1])
      );
      return this.getAverage(arr)
    },
    cfuShortest(){
      var arr = [];
      this.taskProgressObject.forEach((item) =>
        arr.push(item[0] + item[1])
      );
      return Math.min(...arr)
    },
    cfuLongest(){
      var arr = [];
      this.taskProgressObject.forEach((item) =>
        arr.push(item[0] + item[1])
      );
      return Math.max(...arr)
    }
  },
  methods: {
    getAverage: function(arr){
      var arrSum = arr.reduce(function(a,b){
        return a+b;
      }, 0);
      const average = arrSum / Number(this.groupLength)
      // console.log(average)
      return average;
    },
    timeParse: function(time) {
      return this.$filters.timeFormat(time);
    }
  }
}
</script>

<style>


</style>
